import React from 'react';

const CustomTable = ({ columns, data, actions }) => {
    // Si no hay datos, muestra un mensaje amigable
    if (!data || data.length === 0) {
        return <p style={{ textAlign: 'center', marginTop: '20px' }}>No hay datos para mostrar.</p>;
    }

    return (
        <div style={{ overflowX: 'auto', width: '100%' }}>
            <table className="table" style={{ width: '100%' }}>
                <thead>
                    <tr>
                        {columns.map((col, index) => (
                            <th key={index}>{col.header}</th>
                        ))}
                        {actions && <th>Acciones</th>}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {columns.map((col, colIndex) => {
                                // ✅ FIX: Obtener el valor correctamente
                                // Si accessor es una función, la ejecutamos
                                const cellValue = typeof col.accessor === 'function' 
                                    ? col.accessor(row, rowIndex) 
                                    : row[col.accessor];

                                return (
                                    <td key={colIndex}>
                                        {/* ✅ FIX: Pasar TANTO el valor como la fila completa */}
                                        {col.render 
                                            ? col.render(cellValue, row) 
                                            : cellValue
                                        }
                                    </td>
                                );
                            })}
                            {actions && <td>{actions(row)}</td>}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default CustomTable;